export const PlayIcon = (props) => {
  const {
    fill = 'currentColor',
    className,
  } = props;

  return (
    <svg
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_4496_251"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_4496_251)">
        <path d="M8.28577 18V6L17.7143 12L8.28577 18Z" fill={fill} />
      </g>
    </svg>
  );
};

export const PauseIcon = (props) => {
  const {
    fill = 'currentColor',
    className,
  } = props;

  return (
    <svg
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_4496_250"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_4496_250)">
        <path d="M13.7143 18V6H17.1429V18H13.7143ZM6.85718 18V6H10.2857V18H6.85718Z" fill={fill} />
      </g>
    </svg>
  );
};

export const IconArrowRight = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.525 19.1L18.975 12.625C19.075 12.5417 19.1457 12.4457 19.187 12.337C19.229 12.229 19.25 12.1167 19.25 12C19.25 11.8833 19.229 11.7707 19.187 11.662C19.1457 11.554 19.075 11.4583 18.975 11.375L12.525 4.90001C12.375 4.76668 12.2 4.69568 12 4.68701C11.8 4.67901 11.625 4.75001 11.475 4.90001C11.325 5.05001 11.246 5.22501 11.238 5.42501C11.2293 5.62501 11.3 5.80834 11.45 5.97501L16.75 11.25H5.125C4.925 11.25 4.75 11.3207 4.6 11.462C4.45 11.604 4.375 11.7833 4.375 12C4.375 12.2167 4.45 12.3957 4.6 12.537C4.75 12.679 4.925 12.75 5.125 12.75H16.75L11.45 18.05C11.3167 18.1833 11.246 18.354 11.238 18.562C11.2293 18.7707 11.3 18.95 11.45 19.1C11.6 19.25 11.779 19.325 11.987 19.325C12.1957 19.325 12.375 19.25 12.525 19.1Z"
      fill="currentColor"
    />
  </svg>
);

export const IconArrowLeft = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1 19.1L4.65 12.625C4.55 12.5417 4.47933 12.4457 4.438 12.337C4.396 12.229 4.375 12.1167 4.375 12C4.375 11.8833 4.396 11.7707 4.438 11.662C4.47933 11.554 4.55 11.4583 4.65 11.375L11.1 4.90001C11.25 4.76668 11.425 4.69568 11.625 4.68701C11.825 4.67901 12 4.75001 12.15 4.90001C12.3 5.05001 12.379 5.22501 12.387 5.42501C12.3957 5.62501 12.325 5.80834 12.175 5.97501L6.875 11.25H18.5C18.7 11.25 18.875 11.3207 19.025 11.462C19.175 11.604 19.25 11.7833 19.25 12C19.25 12.2167 19.175 12.3957 19.025 12.537C18.875 12.679 18.7 12.75 18.5 12.75H6.875L12.175 18.05C12.3083 18.1833 12.379 18.354 12.387 18.562C12.3957 18.7707 12.325 18.95 12.175 19.1C12.025 19.25 11.846 19.325 11.638 19.325C11.4293 19.325 11.25 19.25 11.1 19.1Z"
      fill="currentColor"
    />
  </svg>
);
